export default __webpack_public_path__ + "static/media/icon_calendar.0fd866bb.svg";